import { Component, OnInit, ViewChild, ViewChildren, AfterViewInit, Input, Output, EventEmitter, OnChanges, TemplateRef } from '@angular/core';
import { PHBHPFeaturePackageSOPManagementService } from '../ph-bhp-feature-package-sopmanagement.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { SopStep, StepCard, HandDisinfectionIndicators, SopDetail } from '../Models';
import { PhBhpSopStepComponent } from '../ph-bhp-sop-step/ph-bhp-sop-step.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { sop } from './sop';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDragStart,
  CdkDropList, CdkDropListGroup,
} from '@angular/cdk/drag-drop';
import { json } from '@angular-devkit/core';
import { TranslationKeys } from 'ph-bhp-localization';
@Component({
  selector: 'lib-ph-bhp-view-sop',
  templateUrl: './ph-bhp-view-sop.component.html',
  styleUrls: ['./ph-bhp-view-sop.component.css']
})

export class PhBhpViewSOPComponent implements OnInit {

  sopIndex: number;
  size = 3;
  arrays: any = [];
  list: any = [];
  @Input() sopStepsList: Array<SopStep> = [];
  sopStep: SopStep = sop();
  updateSubmitted = false;
  activeIndex: number;
  searchText: string;
  sopDetails: SopDetail = {} as SopDetail;
  sopList: Array<SopDetail> = [];
  pageTitle = 'SOP_MANAGEMENT.PREVIEW_WORK_ROUTINE';
  handDisinfectionIndicators: Array<HandDisinfectionIndicators>;
  blobImage: any = {};
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;
  @ViewChildren('cdkDragList') cdkDragList;
  @ViewChildren('sopLine') sopLineList;
  @ViewChild('modelSopDescription') modelSopDescription;
  @ViewChild('modelSopTitle') modelSopTitle;
  @ViewChild('disclaimerModal') disclaimerModal: TemplateRef<any>;
  @ViewChild('cancelmodal') cancelmodal: TemplateRef<any>;
  @ViewChildren('card') cards;
  @ViewChild('cardHolder') cardHolder;
  @Input() sopId: number;
  @Input() sopVersionNo: number;
  @Input() viewType: string;
  @Input() userData: any;
  @Input() isDownload = false;
  @Input() isDesktop = true;
  userFlag = true;
  IAgree;
  modelAgree = false;
  @Output() action = new EventEmitter();
  countriesList: Array<any> = [];
  institutionList: Array<any> = []
  @ViewChild('sopStepComponent') sopStepComponent: PhBhpSopStepComponent;
  //modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  @ViewChild('pdf') pdfGenerator: any;
  isSOPPuzzlevalue;
  resizeFlage = true;
  public target: CdkDropList;
  public targetIndex: number;
  public sourceIndex: number;
  institutionChecked: Object = {};
  countryChecked: Object = {};
  newList: any[];
  translationKeys: typeof TranslationKeys = TranslationKeys
  constructor(private sanitizer: DomSanitizer, public service: PHBHPFeaturePackageSOPManagementService, public layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public translate: TranslateService, public modalRef: BsModalRef) { }

  async ngOnInit() {
    await this.initializeData();
    if (this.isDownload) {
      this.layoutService.showLoader = true;
      this.callTimeoutDownload(true);
    }
  }

  async initializeData() {
    this.service.isCollapsed = false;


    if (this.sopId) {

      this.service.getSOPById(this.sopId).subscribe((res: SopDetail) => {
        this.service.getSopVersionsImages(this.sopId).subscribe((sopImages: any) => {
          this.sopDetails = res;
          if (this.sopDetails.isSOPPuzzle == true || this.sopDetails.accessType == "Global") {
            this.isSOPPuzzlevalue = "Yes";
          }
          else {
            this.isSOPPuzzlevalue = "No";
          }
          if (this.sopDetails.sopInstitutions) {
            if (Array.isArray(this.sopDetails.sopInstitutions)) {
              var institutions = this.sopDetails.sopInstitutions.map(x => `${x.institutionID}`);
              institutions.forEach(x => this.institutionChecked[x] = true);

            } else {
              this.institutionChecked[this.sopDetails.sopInstitutions.institutionID] = true;
            }
          }

          if (this.sopDetails.sopCountries) {
            if (Array.isArray(this.sopDetails.sopCountries)) {
              var countries = this.sopDetails.sopCountries.map(x => `${x.countryID}`);
              countries.forEach(x => this.countryChecked[x] = true);
            } else {
              this.countryChecked[this.sopDetails.sopCountries.countryID] = true;
            }
          }

          if (this.sopVersionNo != null) {
            // specific versionNo should be shown
            if (this.sopVersionNo == 0) {
              // show draft
              this.sopStepsList = JSON.parse(this.sopDetails.draftStepsJson)
            } else {
              // show published version
              const version =
                this.sopDetails.sopStepsVersions
                  .find(version => version.versionNo == this.sopVersionNo);
              this.sopStepsList = JSON.parse(version.stepsJsonFile)
              this.sopDetails.draftComments = version.comments

              // TODO handle invalid versionNo Input with error or fallback
            }

          } else if (this.sopDetails.draftStepsJson) {
            // no specific version was requested, but there is a draft
            this.sopStepsList = JSON.parse(this.sopDetails.draftStepsJson);
            this.sopDetails.sopImage = sopImages.find(x => x.versionNo == 0).imageUrl;

          } else if (this.sopDetails.sopStepsVersions[0].stepsJsonFile) {
            // no specific version was requested and no draft, show last version

            // find last / highest version
            let lastVersion = 0;
            for (const v of this.sopDetails.sopStepsVersions) {
              if (v.versionNo > lastVersion) {
                lastVersion = v.versionNo;
              }
            }

            this.sopStepsList = JSON.parse(this.sopDetails.sopStepsVersions[lastVersion].stepsJsonFile)
            this.sopDetails.draftComments = this.sopDetails.sopStepsVersions[lastVersion].comments;
            this.sopDetails.sopImage = sopImages.find(x => x.versionNo == lastVersion).imageUrl;
          }
          this.callTimeOutLine();
        });
      });
    } else if (this.sopStepsList.length == 0) {
      this.sopStepsList = [sop()];
      this.sopDetails.accessType = "Global"
    }
    this.service.getHandDisinfectionIndicators().subscribe((res: [HandDisinfectionIndicators]) => {

      this.handDisinfectionIndicators = res;
      //this.callTimeOutLine();
    })

    if (this.userData) {
      this.userFlag = false;
      var roleId = this.userData.roleName.roleId;

      if (roleId == 1) {
        this.service.getSOPCountriesList().subscribe((res: Array<any>) => {
          this.countriesList = res;
          this.filterContries(this.countriesList);
        })
      } else {
        this.service.getUsersInstitutions(this.userData.userId, roleId).subscribe((res) => {

          this.institutionList = res;
        })
      }
    }
  }

  filterContries(list) {
    let filteredList: Array<ContriesList> = [];
    let isCountryChanged = true;
    let tempIndex = -1;
    list.forEach((country, i) => {
      isCountryChanged = true;
      country.institutionList.forEach((institution, index) => {
        if (this.institutionChecked[institution.institutionID] || this.countryChecked[country.countryID]) {
          if (isCountryChanged) {
            isCountryChanged = false;
            tempIndex++;
            filteredList.push({
              countryName: country.countryName,
              institutionList: [institution]
            })
          } else {
            filteredList[tempIndex].institutionList.push(institution);
          }
        }
      });
    });
    // this.newList = this.groupBy(filteredList, function (item) {
    //   return [item.countryName];
    // });

    this.newList = filteredList;
  }

  checkAll(ev) {
    this.institutionList.forEach(x => this.institutionChecked[x.institution.institution.institutionID] = ev.target.checked)
  }
  submitData() {

    this.action.emit({ key: 'closeViewModal' });
  }
  cancelSOP() {
    this.action.emit({ key: "cancel" });
  }

  removeCardForMobileApp() {
    this.sopStepsList.splice(this.sopIndex, 1);
  }
  editImage() {
    this.sopStepComponent.openModal(null);
  }
  openSingleSOPSave(index) {
    //Object.assign({}, sop)
    var newSop = sop();
    if (index != null) {
      this.sopStepsList.splice(index, 0, newSop);
    } else {
      this.sopStepsList.push(newSop)
    }
    //this.openSingleSOPUpdate(index, this.isUpdate )
  }

  shuffle() {
    this.sopStepsList.sort(function () {
      return .5 - Math.random();
    });
  }

  removeCardLine() {
    var childNodes = this.cardHolder.nativeElement.childNodes;
    childNodes.forEach((child, index) => {

      if (child.classList && child.classList.contains('horz-Line')) {

        child.remove()
      }
    })
  }

  cardNextLine() {
    var winWidth = window.innerWidth;
    let addChildNodeAtLast = false;
    this.cards.forEach((card, index) => {
      var phElement = card.nativeElement;
      if (this.cards._results[index + 1]) {
        this.cards._results[index + 1].nativeElement.classList.remove('nextRowFirstCard');
      }
      phElement.classList.remove('rowLastCard')

      var childNodes = phElement.childNodes[0];
      if (childNodes.classList && childNodes.classList.contains('rowLastCard1')) {
        childNodes.remove()
      }
      if (childNodes.classList && childNodes.classList.contains('nextRowFirstCard1')) {
        childNodes.remove()
      }

      // mutli-step-start-image
      if (this.cards._results[index + 1] && phElement.classList.contains('mutli-step-start-image')) {
        const childNodesOfMultiStack = phElement.childNodes;

        // use for each instead
        childNodesOfMultiStack.forEach(element => {
          if (element.classList && element.classList.contains('start-image-end')) {
            addChildNodeAtLast = true;
            element.remove();
          }
        });
      }
      var mutliStep = false;
      if (phElement.classList.contains('mutli-step-sub-cards')) {
        mutliStep = true;
      }
      var cardWidth = phElement.offsetWidth;
      var cardHeight = phElement.offsetHeight;
      var cardLeft = phElement.offsetLeft;
      var cardTop = phElement.offsetTop;
      var difWidth = winWidth - (cardWidth + cardLeft);
      var difHeight = cardTop + cardHeight;
      if (mutliStep) {
        var tempCardWidth = cardWidth;
      } else {
        var tempCardWidth = cardWidth + 14;
      }

      if (mutliStep) {
        var difWidth = winWidth - (cardWidth - 14 + cardLeft);
      } else {
        var difWidth = winWidth - (cardWidth + cardLeft);
      }

      if (difWidth < (tempCardWidth + 26)) {

        phElement.classList.add('rowLastCard');
        phElement.insertAdjacentHTML('afterbegin', `<div class='rowLastCard1'></div>`);
        if (this.cards._results[index + 1]) {
          var phElement1 = this.cards._results[index + 1].nativeElement;
          phElement1.classList.add('nextRowFirstCard');
          phElement1.insertAdjacentHTML('afterbegin', `<div class='nextRowFirstCard1'></div>`);
          this.cardHolder.nativeElement.insertAdjacentHTML('afterbegin', "<div class='horz-Line' style='top:" + (difHeight + 14) + "px;width:" + (cardLeft - 9) + "px'></div>");
        }
      }

      if (addChildNodeAtLast && (this.cards.length === index + 1)) {
        addChildNodeAtLast = false;
        let endImage = document.createElement('div');
        endImage.className = 'start-image-end d-flex align-items-center';

        phElement.appendChild(endImage);
      }
    });
  }

  onResize(event) {
    if (this.resizeFlage) {
      this.resizeFlage = false;
      this.removeCardLine();
      this.cardNextLine();
      this.resizeFlage = true;
    }
  }

  expanded(event) {
    this.callTimeOutLine()
  }

  callTimeOutLine() {
    setTimeout(() => {
      this.removeCardLine();
      this.cardNextLine()
    }, 1)
  }

  callTimeoutDownload(hideModal = false) {
    setTimeout(() => {
      const fileName = `${this.sopDetails.title.split('TITLE')[0] + this.layoutService.translateText(this.sopDetails.title, 'SOP_OBSERVATION.NONE')}.pdf`;
        this.pdfGenerator.saveAs(fileName);
        this.layoutService.showLoader = false;
        if (hideModal) {
          this.modalRef.hide();
        }
    }, 5000);
}


  getBlobImageStream(url) {
    if (!this.blobImage[url]) {
      this.blobImage[url] = encodeURIComponent(url);
      this.service.getBlobImageStream(this.blobImage[url]).subscribe(res => {
        this.blobImage[url] = this.sanitizer.bypassSecurityTrustUrl(res.imageBase64);
      })
    }

    return this.blobImage;
  }

  getSopTitle() {
    return `SOP_${this.sopId}_${this.sopVersionNo}.TITLE`;
  }

  getSopDescription() {
    return `SOP_${this.sopId}_${this.sopVersionNo}.DESCRIPTION`;
  }

}
function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
};

export interface ContriesList {
  countryName: string;
  institutionList: Array<any>;
}
